import React from 'react';
import { useTranslation } from 'react-i18next';

function Form() {
  const [result, setResult] = React.useState("");
  const [emailError, setEmailError] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");

  const validateEmail = (email) => {
    // Osnovna validacija formata email-a
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Provera da li sadrži samo dozvoljene karaktere za broj telefona
    const phoneRegex = /^[0-9+\-()\s]+$/;
    return phoneRegex.test(phone);
};


  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Šalje se...");
    setEmailError("");
    setPhoneError("");

    const formData = new FormData(event.target);

    const email = formData.get("email");
    const phone = formData.get("phone");

    // Provera email validacije
    if (!validateEmail(email)) {
      setEmailError("Molimo unesite validnu email adresu.");
      setResult("");
      return;
    }

    // Provera validacije broja telefona
    if (!validatePhone(phone)) {
      setPhoneError("Molimo unesite validan broj telefona.");
      setResult("");
      return;
    }

    const accessKey = process.env.REACT_APP_WEB3FORMS_ACCESS_KEY;

    // Provera da li je access_key postavljen
    if (!accessKey) {
      setResult("Greška: Access ključ nije postavljen. Molimo kontaktirajte administratora.");
      return;
    }

    formData.append("access_key", accessKey);

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        setResult("Hvala Vam što ste nas kontaktirali. Vaš obrazac je uspješno poslat i odgovorićemo Vam u najkraćem mogućem roku.");
        event.target.reset();
      } else {
        console.log("Error", data);
        setResult(data.message || "Došlo je do greške pri slanju obrasca.");
      }
    } catch (error) {
      console.error("Greška prilikom povezivanja sa serverom", error);
      setResult("Došlo je do greške pri povezivanju sa serverom. Molimo pokušajte ponovo kasnije.");
    }
  };

  const [t] = useTranslation();

  return (
    <>
      <section id="contact" className="contact-area after-none contact-bg pt-120 pb-120 p-relative fix" style={{ background: "#f7e6f0" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 order-2">
              <div className="contact-bg">
                <div className="section-title center-align text-center mb-50">
                  <h2>{t("kontakt.obrazac")}</h2>
                </div>
                <form onSubmit={onSubmit} className="contact-form mt-30 text-center">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="contact-field p-relative c-name mb-30">
                        <input type="text" id="firstn" name="name" placeholder="Ime" required />
                        <i className="icon fal fa-user" />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="contact-field p-relative c-subject mb-30">
                        <input 
                          type="email" 
                          id="email" 
                          name="email" 
                          placeholder="Email" 
                          required 
                          onBlur={(e) => {
                            if (!validateEmail(e.target.value)) {
                              setEmailError("Molimo unesite validnu email adresu.");
                            } else {
                              setEmailError("");
                            }
                          }}
                        />
                        <i className="icon fal fa-envelope" />
                        {emailError && <p className="error">{emailError}</p>}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="contact-field p-relative c-subject mb-30">
                        <input 
                          type="text" 
                          id="phone" 
                          name="phone" 
                          placeholder="Broj telefona" 
                          required 
                          pattern="[0-9+\-\(\)\s]*" 
                          onInput={(e) => {
                            if (!validatePhone(e.target.value)) {
                              setPhoneError("Molimo unesite validan broj telefona.");
                            } else {
                              setPhoneError("");
                            }
                          }}
                        />
                        <i className="icon fal fa-phone" />
                        {phoneError && <p className="error">{phoneError}</p>}
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="contact-field p-relative c-message mb-30">
                        <textarea name="message" id="message" cols={30} rows={10} placeholder="Poruka" required />
                        <i className="icon fal fa-edit" />
                      </div>
                      <div className="slider-btn text-center">
                        <button className="btn ss-btn" type="submit" data-animation="fadeInRight" data-delay=".8s">
                          {t("kontakt.obrazacPosalji")} <i className="fal fa-long-arrow-right" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <p>{result}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Form;
